var exports = {
  "A": "ColumnFrame__9Z3IjJ",
};

module.exports = exports;
